import { trackGoogleAdsPageView } from '../util/analytics';
import { trackOpenAiPageView } from '../util/openai';
import { trackRedditPageVisit } from '../util/reddit';

export class LoggingAnalyticsHandler {
  trackPageView(url) {
    console.log('Analytics page view:', url); // eslint-disable-line no-console
  }
}

// Google Analytics 4 (GA4) using gtag.js, injected after load via util/DeferredAnalyticsScripts.js
export class GoogleAnalyticsHandler {
  trackPageView(canonicalPath, previousPath) {
    // GA4 property. Manually send page_view events
    // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    // Note 1: You should turn "Enhanced measurement" off.
    //         It attaches own listeners to elements and that breaks in-app navigation.
    // Note 2: If previousPath is null (just after page load), gtag script sends page_view event automatically.
    //         Only in-app navigation needs to be sent manually from SPA.
    // Note 3: Timeout is needed because gtag script picks up <title>,
    //         and location change event happens before initial rendering.
    if (previousPath && window.gtag) {
      window.setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: canonicalPath,
        });
        // Same navigation for the Google Ads tag (its own gtag group, see util/analytics.js).
        // No-op unless REACT_APP_GOOGLE_ADS_ID is set.
        trackGoogleAdsPageView();
      }, 300);
    }
  }
}

// Reddit Ads Pixel, eingebunden über util/DeferredAnalyticsScripts.js.
// Der erste PageVisit wird beim Init des Pixels gemeldet — hier geht es nur um
// die In-App-Navigation (SPA), die Reddit sonst nie sieht.
export class RedditPixelHandler {
  trackPageView(canonicalPath, previousPath) {
    // previousPath ist beim ersten Aufruf null: dieser Seitenaufruf steckt
    // bereits im Init, ein zweiter PageVisit wäre eine Doppelzählung.
    if (previousPath) {
      trackRedditPageVisit();
    }
  }
}

// OpenAI Ads Pixel, eingebunden über util/DeferredAnalyticsScripts.js.
// Wie bei Reddit steckt der erste Seitenaufruf bereits im Init — das SDK meldet
// von sich aus keinen.
export class OpenAiPixelHandler {
  trackPageView(canonicalPath, previousPath) {
    if (previousPath) {
      trackOpenAiPageView();
    }
  }
}
